import styled from "styled-components";

export const DateRangePickerStyled = styled.div`
  width: 100%;
  .ant-picker {
    border-color: #545f71;
    position: relative;
    color: #545f71;

    input {
      border: none !important;
      padding: 8px !important;
    }
  }
  .ant-picker-dropdown {
    z-index: 1056111111111111111;
  }

  .ant-picker.ant-picker-range span.ant-picker-suffix {
    color: #545f71;
  }

  .ant-picker-input > input::placeholder {
    color: #545f71;
  }
  .ant-picker-outlined.ant-picker-disabled {
    background-color: white;
    opacity: 0.7 !important;
  }
`;
